// src/plugins/windowSize.js
import { isMobile } from '@/composables/windowSizeShared'

export default {
  install(app) {
    app.provide('isMobile', isMobile)
  }
}
